<script>
import { pluck } from 'rambda'

export default {
  computed: {
    laptopIdsSelected() {
      return pluck('laptopId', this.articleLaptops)
    },
  },
  methods: {
    setLaptopIdIsSelected(laptopId, isSelected) {
      return this.setLaptopIsSelected({
        laptopId,
      }, isSelected)
    },
    async setLaptopIsSelected(articleLaptop, isSelected) {
      const { laptopId } = articleLaptop

      const articleLaptops = (() => {
        if (!isSelected) {
          return this.articleLaptops
            .filter(articleLaptop => articleLaptop.laptopId !== laptopId)
            .filter(articleLaptop => articleLaptop.alternativeToLaptopId !== laptopId)
        }

        const { price } = this.laptopEvaluations
          .find(laptopEvaluation => laptopEvaluation.id === laptopId)

        const articleLaptopWithPrice = {
          ...articleLaptop,
          price,
        }

        return [
          ...this.articleLaptops,
          articleLaptopWithPrice,
        ]
      })()

      this.setArticleLaptops(articleLaptops)
    },
  },
  render: () => '',
}
</script>
